import client from './client';
import { getRequestData } from './index';

export default (cid: string, error: string, data: any) => {
  client.error('WillSurfaceErrorPage', {
    cid,
    error,
    data,
    context: 'hooks/useGetContext',
    ...getRequestData(),
  });
};